export function isSessionInactive(sessionLengthInMinutes = 30) {
    const lastActive = localStorage.getItem("glean_session_last_active");
    const lastActiveDate = new Date(Number(lastActive));
    const inactiveThreshold = new Date();
    inactiveThreshold.setMinutes(inactiveThreshold.getMinutes() - sessionLengthInMinutes);
    return inactiveThreshold > lastActiveDate;
}
